import { TransformFloat } from '../../../shared/decorators/transform-float.decorator';
import { TransformInt } from '../../../shared/decorators/transform-int.decorator';
import { TransactionTypeEnum } from '../../transactions/enums/transaction-type.enum';

/**
 * Send payment link request DTO.
 * All fields except amount are optional. When used with rental agreement or
 * reservation endpoints, recipientEmail, payerFirstName, payerLastName and
 * description can be omitted and are derived from the linked customer/contact.
 * For standalone use (payments controller), recipientEmail is required.
 */
export class SendPaymentLinkRequestDto {
	@TransformFloat()
	amount!: number;
	@TransformInt()
	expirationDays?: number;
	/** Payment description. Omitted when derived from target. */
	description?: string;
	/** Recipient email. Required for standalone; omitted when derived from customer. */
	recipientEmail?: string;
	/** Payer first name. Omitted when derived from customer. */
	payerFirstName?: string;
	/** Payer last name. Omitted when derived from customer. */
	payerLastName?: string;
	/** Payer company name. Omitted when derived from customer. */
	payerCompanyName?: string;
	/**
	 * Transaction type (RECEIPT, DEPOSIT) when creating from RA/RR.
	 * Omitted when target is TRANSACTION (type comes from existing record).
	 */
	transactionType?: TransactionTypeEnum;
}
